<div class="btn-group dropdown-filters" dropdown [autoClose]="autoCloseDropdownFilters">
  <button
    type="button"
    class="btn btn-secondary-primary dropdown-toggle"
    [class.btn-filters-active]="form | isFiltering : ['includeDeletedInquiries']"
    dropdownToggle
  >
    <span class="fal fa-filter"></span>
    <ng-container i18n>Filters</ng-container>
  </button>
  <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu (click)="$event.stopPropagation()" style="width: 300px">
    <li>
      <app-rental-select
        class="w-auto"
        [showCloseButton]="true"
        (openedChange)="autoCloseDropdownFilters = !$event"
        [ctrl]="form.get('rentals')"
        i18n-placeholder
        placeholder="Rental"
      ></app-rental-select>
    </li>
    <li>
      <app-select-search
        class="w-auto"
        [inline]="false"
        [showCloseButton]="true"
        (openedChange)="autoCloseDropdownFilters = !$event"
        bindValue="value"
        bindLabel="name"
        [items]="sourceOptions"
        [ctrl]="form.get('sources')"
        i18n-placeholder
        placeholder="Channel"
      ></app-select-search>
    </li>
    <li>
      <app-select-search
        class="w-auto"
        [inline]="false"
        [multiple]="false"
        [showCloseButton]="true"
        [hasBlank]="true"
        blankLabel="All"
        (openedChange)="autoCloseDropdownFilters = !$event"
        bindValue="value"
        bindLabel="name"
        [items]="reviewerRolesOptions"
        [ctrl]="form.get('reviewerRole')"
        i18n-placeholder
        placeholder="Review by"
      ></app-select-search>
    </li>
    <li>
      <app-select-search
        class="w-auto"
        [inline]="false"
        [multiple]="false"
        [showCloseButton]="true"
        [hasBlank]="true"
        blankLabel="All"
        (openedChange)="autoCloseDropdownFilters = !$event"
        bindValue="value"
        bindLabel="name"
        [items]="ratingCategoryOptions"
        [ctrl]="form.get('category')"
        i18n-placeholder
        placeholder="Category"
      ></app-select-search>
    </li>
    <li>
      <app-select-search
        class="w-auto"
        [inline]="false"
        [showCloseButton]="true"
        (openedChange)="autoCloseDropdownFilters = !$event"
        bindValue="value"
        bindLabel="name"
        [items]="ratingValueOptions"
        [ctrl]="form.get('ratings')"
        i18n-placeholder
        placeholder="Ratings"
      ></app-select-search>
    </li>
    <li>
      <mat-form-field2 class="mat-block">
        <app-mat-daterange-input
          i18n-placeholder
          placeholder="Date Range"
          [formControl]="form.get('submitted')"
        ></app-mat-daterange-input>
      </mat-form-field2>
    </li>
    <li>
      <app-form-switch
        i18n-matTooltip
        matTooltip="Include reviews for deleted bookings"
        [formControl]="form.get('includeDeletedInquiries')"
        i18n
        >Include Deleted Bookings</app-form-switch
      >
    </li>
  </ul>
</div>

<app-cancel-filters [isFiltering]="form | isFiltering" [filterControl]="form"></app-cancel-filters>

<button
  class="btn btn-secondary-primary"
  (click)="onRefresh()"
  i18n-matTooltip
  matTooltip="Refresh List"
  matTooltipPosition="above"
>
  <i class="far fa-sync"></i>
</button>
